export default "__VITE_ASSET__C70eN3lm__"